module.exports = __webpack_public_path__ + "static/media/VeevaModule.e50a5921.svg";